/* eslint-disable no-console */
const trackLongTasks =
  window.location.hostname === 'localhost' || window.location.hostname.startsWith('vbox');

const longTasks: PerformanceEntry[] = [];
const longThreshold = 100;
let observer: PerformanceObserver;

if (trackLongTasks) {
  observer = new PerformanceObserver(list => {
    list.getEntries().forEach((entry: PerformanceEntry) => {
      if (entry.duration > longThreshold) {
        longTasks.push(entry.toJSON());
      }
    });
  });

  observer.observe({
    entryTypes: ['longtask']
  });
}

export const dumpLongTasks = () => {
  if (trackLongTasks && longTasks.length) {
    console.groupCollapsed('LONG TASKS');
    while (longTasks.length > 0) {
      console.warn(longTasks.shift());
    }

    console.groupEnd();
  }
};

export const getObserver = () => observer;
